module.exports = __webpack_public_path__ + "static/img/help11.a9e84a2a.jpg";